/**
 * There will be one reducer file per common component
 */
import {
    GET_DEV_DATA_SUCCESS,
    GET_DEV_DATA_FAILURE,
    GET_DEV_DATA,
} from 'src/common/redux/actions/constants';

const initialState = {
    devData: {
        enableIDPAuth: true,
    },
    devDataError: '',
    devLoading: false,
};

const DevReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DEV_DATA:
            return {
                ...state,
                devLoading: true,
            };
        case GET_DEV_DATA_SUCCESS:
            return {
                ...state,
                devData: action.devData,
                devDataError: '',
                devLoading: false,
            };
        case GET_DEV_DATA_FAILURE:
            return {
                ...state,
                devData: [],
                devDataError: action.payload.templateError,
                devLoading: false,
            };
        default: {
            return { ...state };
        }
    }
};

export default DevReducer;
